module.exports = __webpack_public_path__ + "img/blanktab.4946b8db.jpg";